import { dateComparator } from "utils/comparatorUtils";
import { dateRangeFilter, formatDateLocalTZ } from "utils/utils";
import { USERS_TABLE_STRINGS } from "constants/constantStrings";

import UserDeleteRenderer from "./UserDeleteRenderer";
import UserEditRenderer from "./UserEditRenderer";

export const getUsersTableColConf = filter => [
  {
    field: "Email",
    headerName: USERS_TABLE_STRINGS.emailID,
    defaultSort: "asc",
    flex: 2.5,
    editable: false,
    filter
  },
  {
    field: "Name",
    headerName: USERS_TABLE_STRINGS.userName,
    flex: 1.5,
    editable: false,
    filter
  },
  {
    field: "Systems",
    headerName: USERS_TABLE_STRINGS.userSystems,
    editable: false,
    flex: 1.5,
    filter,
    width: 350
  },
  {
    field: "Role",
    headerName: USERS_TABLE_STRINGS.userRole,
    editable: false,
    flex: 1,
    filter,
    width: 120
  },
  {
    field: "Status",
    headerName: USERS_TABLE_STRINGS.userStatus,
    editable: false,
    flex: 1,
    valueFormatter: ({ data }) => (data.Status ? USERS_TABLE_STRINGS.userStatusActive : USERS_TABLE_STRINGS.userStatusInactive),
    filter,
    width: 120
  },
  {
    field: "LastLogin",
    flex: 2,
    headerName: USERS_TABLE_STRINGS.userLastLogin,
    editable: false,
    width: 200,
    filter: "agDateColumnFilter",
    filterParams: dateRangeFilter,
    newRowsAction: "keep",
    valueFormatter: params => formatDateLocalTZ(params.data?.LastLogin),
    comparator: dateComparator
  },
  {
    colId: "edit",
    lockPinned: true,
    pinned: "right",
    editable: false,
    width: 50,
    cellRendererFramework: UserEditRenderer
  },
  {
    colId: "delete",
    lockPinned: true,
    pinned: "right",
    editable: false,
    width: 50,
    cellRendererFramework: UserDeleteRenderer
  }
];

export const DEFAULT_USER_DATA = {
  Email: "",
  Mobile: "",
  Role: "",
  SsoId: "",
  Status: true,
  Systems: []
};
